import { track } from "../analytics";
import type { PartnerInfo, PartnerLinkKind } from "@gooner/shared";

/**
 * Where a partner credit was opened from.
 *
 * A new caller of PartnerDialog adds a member HERE and nothing else — which is what makes
 * the dialog reusable rather than merely copyable, and what keeps the funnel able to say
 * WHICH surface converted once there is more than one.
 */
export type PartnerSource = "channel_row";

/** The credit was read. NOT deduped, unlike gold's impressions: that one renders on every
 *  render, so rendering is not intent — this one mounts on a deliberate press, so a second
 *  open is a second real read, and collapsing them would destroy the funnel's denominator. */
export const trackPartnerShown = (partner: PartnerInfo, source: PartnerSource): void =>
  track("partner_shown", { partner: partner.id, source });

/** THE CONVERSION — the number a partner is actually owed. The link's KIND travels, never
 *  its url and never its label, because a label is copy that can be rewritten and a url is
 *  the thing this file exists not to send. */
export const trackPartnerLink = (partner: PartnerInfo, link: PartnerLinkKind): void =>
  track("partner_link_clicked", { partner: partner.id, link });
